import React, { useState, useEffect } from 'react';
import { EmptyState } from '@/components/custom/empty-state';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { ExercisesMetricsChartAverageAccess } from './exercises-metrics-chart-average-access';
import { useTranslation } from 'react-i18next';
import { Widget, WidgetHeader, WidgetTitle, WidgetBody } from '@/components/custom/widget';

export function ExercisesMetricsWidgetAverageAccess(props) {
  const { t } = useTranslation();
  const { title, timeFilterSelected } = props;
  const client = useClient();
  const [averageAccess, setAverageAccess] = useState([]);
  const [duration, setDuration] = useState(0);
  const [name, setName] = useState();

  const getAverageAnsweringTime = async () => {
    const { data, error } = await client.fetch(`reports/question_books/average_answering_time?week=${timeFilterSelected}`);

    if (error) {
      toast.error(t('toast.errorGetMetrics'));
    } else {
      setAverageAccess(data);
      setDuration((data?.items || []).map(i => i[1]).reduce((sum, i) => sum + i, 0));
    }
  };

  useEffect(() => {
    getAverageAnsweringTime();
  }, [timeFilterSelected]);

  return (
    <Widget>
      <WidgetHeader>
        <WidgetTitle>{title || 'Média de acessos'}</WidgetTitle>
      </WidgetHeader>

      {duration > 0 ? (
        <WidgetBody>
          <ExercisesMetricsChartAverageAccess
            name={name}
            color="#442B8C"
            chartData={averageAccess}
            valueSuffix={false}
          />
        </WidgetBody>
      ) : (
        <EmptyState
          variant="plain"
          type="register"
          text={t('emptyState.noAccessFoundForPeriod')}
        />
      )}
    </Widget>
  );
}
